<div
  [class.ant-dropdown-menu]="isMenuInsideDropDown"
  [class.ant-menu]="!isMenuInsideDropDown"
  [class.ant-dropdown-menu-vertical]="isMenuInsideDropDown"
  [class.ant-menu-vertical]="!isMenuInsideDropDown"
  [class.ant-dropdown-menu-sub]="isMenuInsideDropDown"
  [class.ant-menu-sub]="!isMenuInsideDropDown"
  [class.ant-menu-rtl]="dir === 'rtl'"
  [ngClass]="menuClass">
  <ng-template [ngTemplateOutlet]="templateOutlet"></ng-template>
</div>
